export default __webpack_public_path__ + "static/media/about1.c99ab6ad.webp";